<template>
  <div class="col-xs-12 col-md-12">
    <div class="row">  
{{tile}}
        <div v-for="(condition,index) in tile.colorConditions">

          <div v-if="tile.value >= condition.minValue & tile.value < condition.maxValue">


            <div v-if="tile.width=='Small'" class="col-lg-2">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="tile.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{tile.value}}</span> <span class="h6 text-white-op">{{tile.label}}</span>
                    </div>
                </a>
            </div>


            <div v-if="tile.width=='Medium'" class="col-lg-3">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="tile.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{tile.value}}</span> <span class="h6 text-white-op">{{tile.label}}</span>
                    </div>
                </a>
            </div>


            <div v-if="tile.width=='Large'" class="col-lg-4">
                <a class="block block-link-hover2 text-center">
                    <div class="block-content block-content-full" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <div class="font-w600 text-white-op push-5-t">{{tile.label}}</div>
                        <i v-bind:class="tile.favIcon" class="fa-2x text-white"></i>
                        <div class="h4 text-white">{{tile.value}} {{tile.valueSufix}}</div>
                    </div>
                </a>
            </div>


            <div v-if="tile.width=='Full'" class="col-lg-12">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="tile.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{tile.value}}</span> <span class="h6 text-white-op">{{tile.label}}</span>
                    </div>
                </a>
            </div>
        </div>

      </div>

    </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'

export default {
  props: ['tile'],

  data() {
    return {
      actualLanguage : "FR",
      testColor : '#46c37b'
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData']),
  },
  watch: {


  },
  methods: {
  

    },



  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'} 

  },



}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CustomDashboardTileV1p00.vue?cb529dc6